import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  as?: 'h2' | 'h3';
  className?: string;
}

/** Use when a list or page has no data yet; explains why and offers a next action. */
// Inside a table, render it within <TableRow><TableCell colSpan={...}>.
export function EmptyState({ icon: Icon, title, description, action, as: Title = 'h2', className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed py-14 text-center', className)}>
      {Icon && <Icon className="size-8 text-muted-foreground" aria-hidden />}
      <div className="space-y-1">
        <Title className="font-medium">{title}</Title>
        {description && <p className="mx-auto max-w-sm text-sm text-muted-foreground">{description}</p>}
      </div>
      {action}
    </div>
  );
}
